var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.visible
    ? _c(
        "div",
        { staticClass: "nav vue-version-switch" },
        [
          _c(
            "button",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.displaySwitcher,
                  expression: "!displaySwitcher"
                }
              ],
              ref: "vueVersionSwitch",
              staticClass: "vue-version-switch__display-switcher-btn",
              attrs: { id: "vueVersionSwitch" },
              on: { click: _vm.toggleSwitcher }
            },
            [
              _c("i", { staticClass: "icon icon-swap" }),
              _vm.showTooltip
                ? _c("Tooltip", [_vm._v(" Change Screen Layout ")])
                : _vm._e()
            ],
            1
          ),
          _c("Popover", {
            ref: "popover",
            attrs: {
              trackedRefName: "vueVersionSwitch",
              visible: _vm.popoverVisible,
              placement: "right",
              positionStrategy: "fixed",
              container: _vm.popoverOptions.container,
              zIndex: _vm.popoverOptions.zIndex,
              offset: [0, 20]
            },
            on: { close: _vm.onPopoverClose },
            scopedSlots: _vm._u(
              [
                {
                  key: "popoverTitle",
                  fn: function() {
                    return [
                      _c(
                        "div",
                        { staticClass: "vue-version-switch__popover-title" },
                        [
                          _c("i", { staticClass: "icon icon-warning" }),
                          _c(
                            "span",
                            {
                              staticClass:
                                "vue-version-switch__popover-title-text"
                            },
                            [_vm._v(" We have a new look! ")]
                          )
                        ]
                      )
                    ]
                  },
                  proxy: true
                },
                {
                  key: "popoverBody",
                  fn: function() {
                    return [
                      _vm._v(
                        " Click here to enable the updated experience for this screen "
                      )
                    ]
                  },
                  proxy: true
                }
              ],
              null,
              false,
              3776257785
            )
          }),
          _vm.displaySwitcher
            ? _c("div", { staticClass: "vue-version-switch__switcher" }, [
                _c("div", { staticClass: "vue-version-switch__option2" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.selectedVersion,
                        expression: "selectedVersion"
                      }
                    ],
                    staticClass: "vue-version-switch__radio",
                    attrs: {
                      type: "radio",
                      id: "version-2",
                      name: "versionSelector",
                      value: "2"
                    },
                    domProps: { checked: _vm._q(_vm.selectedVersion, "2") },
                    on: {
                      change: [
                        function($event) {
                          _vm.selectedVersion = "2"
                        },
                        _vm.switchVersion
                      ]
                    }
                  }),
                  _c(
                    "label",
                    {
                      staticClass: "vue-version-switch__label",
                      attrs: { for: "version-2" }
                    },
                    [_vm._v(" Modern ")]
                  )
                ]),
                _c("br"),
                _c("div", { staticClass: "vue-version-switch__option1" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.selectedVersion,
                        expression: "selectedVersion"
                      }
                    ],
                    staticClass: "vue-version-switch__radio",
                    attrs: {
                      type: "radio",
                      id: "version-1",
                      name: "versionSelector",
                      value: "1"
                    },
                    domProps: { checked: _vm._q(_vm.selectedVersion, "1") },
                    on: {
                      change: [
                        function($event) {
                          _vm.selectedVersion = "1"
                        },
                        _vm.switchVersion
                      ]
                    }
                  }),
                  _c(
                    "label",
                    {
                      staticClass: "vue-version-switch__label",
                      attrs: { for: "version-1" }
                    },
                    [_vm._v(" Classic ")]
                  )
                ]),
                _vm.displaySwitcher
                  ? _c(
                      "button",
                      {
                        staticClass: "vue-version-switch__hide-switcher",
                        on: { click: _vm.toggleSwitcher }
                      },
                      [_c("i", { staticClass: "icon icon-remove" })]
                    )
                  : _vm._e()
              ])
            : _vm._e()
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }